module.exports = ".form-edit-table {\n    padding: 40px 20px;\n}"